import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import {TransferType} from './transfer-type.model';
import {WithdrawModelDto} from './withdraw-dto.model';

export enum WithdrawRialStatus {
  PENDING = 'PENDING',
  SUCCESSFUL = 'SUCCESSFUL',
  CHECKED_BY_OPERATOR = 'CHECKED_BY_OPERATOR',
  PROCESSING = 'PROCESSING',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  DONE = 'DONE',
  ERROR = 'ERROR'
}

export enum TransferMode {
  ACH = 'ACH',
  NORMAL = 'NORMAL'
}

export class WithdrawModel {
  id: number;
  user: User;
  currency: Currency;
  wallet: string;
  network: string;
  amount: number;
  fee: number;
  status: WithdrawRialStatus;
  statusText!: string;
  message: string;
  createdAt: string;
  updatedAt: string;
  tag: string;
  destinationUser?: User;
  destinationWallet?: string;
  shouldRenderQrCode?: boolean
  shouldRenderMemoQrCode?: boolean
  transferType: TransferType;


  constructor(input: WithdrawModelDto) {
    this.user = new User(input.user);
    this.currency = new Currency(input.currency);
    this.id = input.id;
    this.wallet = input.wallet;
    this.amount = input.amount;
    this.fee = input.fee;
    this.status = input.status;
    if (this.status === WithdrawRialStatus.DONE) {
      this.statusText = 'موفق';
    }
    if (this.status === WithdrawRialStatus.SUCCESSFUL) {
      this.statusText = 'موفق';
    }
    if (this.status === WithdrawRialStatus.PROCESSING) {
      this.statusText = 'در حال انجام';
    }
    if (this.status === WithdrawRialStatus.PENDING) {
      this.statusText = 'در حال بررسی';
    }
    if (this.status === WithdrawRialStatus.FAILED) {
      this.statusText = 'ناموفق';
    }
    if (this.status === WithdrawRialStatus.CANCELED) {
      this.statusText = 'لغوشده';
    }
    this.transferType = input.type_transfer;
    this.message = input.message;
    this.createdAt = input.created_at;
    this.updatedAt = input.updated_at;
    this.tag = input.tag;
    this.shouldRenderQrCode = false
    this.shouldRenderMemoQrCode = false
    this.network = input.network;

    if(input.to_user || this.transferType === TransferType.Internal){
      this.destinationUser = new User(input.to_user);
      this.destinationWallet = input.wallet
    }

  }
}

export class WithdrawRialModel {
  id: number;
  user: User;
  amount: number;
  fee: number;
  status: 'PROCESSING' | 'PENDING' | 'DONE' | 'CANCELED';
  statusText!: string;
  createdAt: string;
  updatedAt: string;

  constructor(input: any = {}) {
    this.user = new User(input.user);
    this.id = input.id;
    this.amount = input.amount;
    this.fee = input.fee;
    this.status = input.status;
    if (this.status === 'DONE') {
      this.statusText = 'انجام شده';
    }
    if (this.status === 'PROCESSING') {
      this.statusText = 'در حال انجام';
    }
    if (this.status === 'PENDING') {
      this.statusText = 'در حال بررسی';
    }
    if (this.status === 'CANCELED') {
      this.statusText = 'کنسل شد';
    }
    this.createdAt = input.created_at;
    this.updatedAt = input.updated_at;
  }
}
